// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as CountryConfig from "../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as ProgressModal from "../../../../../library/components/generic-components/components/ProgressModal.bs.js";
import * as CountryContext from "../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as AdjustFareDashboard from "./form-components/AdjustFareDashboard.bs.js";
import * as CircularLoader$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/CircularLoader.bs.js";
import * as ToastSnackbarHook$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/hooks/toast-notification/ToastSnackbarHook.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";

function AdjustFareHomeCmp(Props) {
  var state = Props.state;
  var dispatch = Props.dispatch;
  var match = ToastSnackbarHook$Catalyst.useSnackbar(5000, undefined, undefined);
  var openSnackbar = match[1];
  var getCurrency = function (param) {
    var match = CountryContext.useContext(undefined);
    return CountryConfig.getSymbol(match.country);
  };
  var currency_symbol = getCurrency(undefined);
  React.useEffect((function () {
          var message = state.snackbar_message;
          if (message !== undefined) {
            Curry._1(openSnackbar, message);
            Curry._1(dispatch, /* ClearSnackbar */0);
          }
          
        }), [state.snackbar_message]);
  var match$1 = state.current_fare_details;
  var match$2 = state.new_fare_datails;
  var tmp;
  var exit = 0;
  var error;
  var exit$1 = 0;
  if (typeof match$1 === "number") {
    exit$1 = 3;
  } else {
    switch (match$1.TAG | 0) {
      case /* Loading */0 :
          exit$1 = 3;
          break;
      case /* Live */1 :
          var current_fare_details = match$1._0;
          if (typeof match$2 === "number") {
            exit = 1;
          } else {
            switch (match$2.TAG | 0) {
              case /* Loading */0 :
                  var new_fare_datails = match$2._0;
                  tmp = new_fare_datails !== undefined ? React.createElement(React.Fragment, undefined, React.createElement(ProgressModal.make, {
                              isOpen: true
                            }), React.createElement(AdjustFareDashboard.make, {
                              currency_symbol: currency_symbol,
                              current_fare_details: current_fare_details,
                              new_fare_details: new_fare_datails,
                              state: state,
                              dispatch: dispatch
                            })) : React.createElement(CircularLoader$Catalyst.make, {});
                  break;
              case /* Live */1 :
                  tmp = React.createElement(React.Fragment, undefined, React.createElement(AdjustFareDashboard.make, {
                            currency_symbol: currency_symbol,
                            current_fare_details: current_fare_details,
                            new_fare_details: match$2._0,
                            state: state,
                            dispatch: dispatch
                          }));
                  break;
              case /* Error */2 :
                  exit$1 = 3;
                  break;
              
            }
          }
          break;
      case /* Error */2 :
          error = match$1._0;
          exit = 2;
          break;
      
    }
  }
  if (exit$1 === 3) {
    if (typeof match$2 === "number" || match$2.TAG !== /* Error */2) {
      exit = 1;
    } else {
      error = match$2._0;
      exit = 2;
    }
  }
  switch (exit) {
    case 1 :
        tmp = React.createElement(CircularLoader$Catalyst.make, {});
        break;
    case 2 :
        tmp = React.createElement(ErrorDisplayComponent$Catalyst.make, {
              error: error
            });
        break;
    
  }
  return React.createElement("div", {
              className: "c-adjust-fare-home"
            }, match[0], tmp);
}

var make = AdjustFareHomeCmp;

export {
  make ,
  
}
/* react Not a pure module */
